import dynamic from 'next/dynamic'

export const PolicySidebar = dynamic(() => import('./policy-sidebar'))
